import React from "react"
import styled from "styled-components"
import { useForm } from "react-hook-form"
import { toast } from "react-hot-toast"
import axios from "axios"
//#region styles
const ContactUsStyles = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #f9f3ec;
  width: 100%;
  padding: 34px 200px 68px;

  .message {
    margin-right: 34px;
    width: 50%;
  }

  .heading {
    font-family: "Amasis", serif;
    color: #3e3120;
    font-size: 26px;
    font-weight: bold;
  }

  .description {
    margin-top: 12px;
    font-size: 14px;
    line-height: 1.875;
    max-width: 500px;
  }
  @media only screen and (max-width: 1263px) {
    padding: 34px 150px 68px;
  }
  @media only screen and (max-width: 1192px) {
    padding: 34px 125px 68px;
    .message {
      width: 50%;
    }
    .heading {
      font-size: 24px;
    }
  }
  @media only screen and (max-width: 1059px) {
    padding: 34px 96px 68px;
    .heading {
      font-size: 22px;
    }
  }
  @media only screen and (max-width: 937px) {
    padding: 34px 64px 68px;
  }
  @media only screen and (max-width: 868px) {
    padding: 34px 64px 68px;
    flex-direction: column;
    .message {
      width: 70%;
      margin: 0;
      text-align: center;
    }
    .heading,
    .description {
      width: 100%;
    }
  }
  @media only screen and (max-width: 700px) {
    padding: 34px 24px 68px;
    .message {
      width: 90%;
    }
  }
`

const SocialIcons = styled.div``

const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  background-color: #fffcf8;
  max-width: 100%;
  width: 50%;
  border: 1px solid #310542;
  box-shadow: 4px 4px 0px #310542;
  padding: 20px;
  position: relative;
  margin-top: -80px;

  > input,
  select,
  textarea {
    padding: 8px 16px;
    font-size: 14px;
    font-family: "Cabin", sans-serif;
    border: 1px solid #eee6e3;
    background: #f9f6f3;
    margin-bottom: 13px;

    ::placeholder {
      color: #c8baaa;
    }
  }

  textarea {
    width: 100%;
    resize: none;
    min-height: 200px;
  }

  button {
    background-color: #310542;
    align-self: flex-end;
    color: #f9f6f3;
    border: 0;
    padding: 8px 27px;
    font-size: 14px;
    font-family: Cabin, sans-serif;
  }
  @media only screen and (max-width: 868px) {
    margin-top: 32px;
    align-self: center;
    width: 70%;
  }
  @media only screen and (max-width: 700px) {
    width: 90%;
  }
`

//#endregion

const ContactUs: React.FC<{}> = function (props) {
  const { register, handleSubmit, reset } = useForm()

  const onSubmit = data => {
    toast.promise(
      axios.post("https://heights-restructuring.herokuapp.com/contact-us", {
        name: data.name,
        contact: data["contact-number"],
        email: data.email,
        type: data["message-type"],
        message: data.message ? data.message : "no message",
      }),
      {
        loading: "Sending response...",
        success: <b>Response sent!</b>,
        error: <b>Failed. Please try again.</b>,
      }
    )
    reset()
  }

  return (
    <ContactUsStyles>
      <div className="message">
        <h2 className="heading">Have something to tell HEIGHTS?</h2>
        <p className="heading">Send us a message!</p>
        <p className="description">
          HEIGHTS is open for event partnerships and folio collaborations, but
          we’re also open to hearing your thoughts on what you see and read from
          us! Fill up the form on the right and send your message. If you have a
          more urgent message for us to read, you may also course it through our
          official social media channels linked below!
        </p>
        <SocialIcons></SocialIcons>
      </div>
      <ContactForm onSubmit={handleSubmit(onSubmit)}>
        <input type="text" placeholder="Name" name="name" ref={register} />
        <input
          type="text"
          placeholder="Contact Number*"
          name="contact-number"
          ref={register({ required: true })}
          required
        />
        <input
          type="email"
          placeholder="Email Address*"
          name="email"
          ref={register({ required: true })}
          required
        />
        <select name="message-type" ref={register({ required: true })}>
          <option value="Partnership Invitation">Partnership Invitation</option>
          <option value="Folio Inquiry">Folio Inquiry</option>
          <option value="Letter to the Editors">Letter to the Editors</option>
          <option value="Others">Others</option>
        </select>
        <textarea
          placeholder="Your message for us.."
          name="message"
          ref={register}
        ></textarea>
        <button type="submit">Send Message</button>
      </ContactForm>
    </ContactUsStyles>
  )
}

export default ContactUs
